import {Component, Input, OnInit} from '@angular/core';

@Component({
	selector: 'app-kamona-loading',
	templateUrl: './kamona-loading.component.html',
	styleUrls: ['./kamona-loading.component.scss']
})
export class KamonaLoadingComponent implements OnInit {

	@Input() size = 50;
	@Input() loadingText: string;
	@Input() loadingType: any;
	@Input() parentHeight = '340';
	@Input() stroke = '#0361F0';
	@Input() strokeOpacity = '.5';
	@Input() strokeWidth = '2';

	constructor() {
	}

	ngOnInit(): void {
		this.initialize();
	}

	initialize() {
		if (!this.loadingType) {
			this.loadingType = 'OLD';
		}
	}

}


